import { applyHighchartsTheme } from "../utils/highcharts_theme"

export const LeaseTermTrends = {
  mounted() {
    this.handleEvent("render-lease-term-trends", ({ chart_data }) => {
      this.renderChart(chart_data)
    })

    // Also render on mount if data is present
    const chartData = this.el.dataset.chart
    if (chartData) {
      this.renderChart(JSON.parse(chartData))
    }
  },

  renderChart(chartData) {
    import("highcharts").then((Highcharts) => {
      applyHighchartsTheme(Highcharts.default)
      Highcharts.default.chart(this.el.id, {
        chart: {
          type: "line",
          // Highcharts 13 defaults chart.backgroundColor to a CSS var that
          // renders dark under prefers-color-scheme: dark; keep it explicit.
          backgroundColor: "transparent",
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: chartData.categories,
          title: {
            text: "Time Period",
          },
        },
        yAxis: {
          title: {
            text: "Lease Term (Months)",
          },
          min: 0,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          valueSuffix: " months",
          valueDecimals: 1,
        },
        plotOptions: {
          line: {
            color: "#10b981",
            dataLabels: {
              enabled: false,
            },
            marker: {
              enabled: true,
              radius: 4,
            },
          },
        },
        series: [
          {
            name: "Median Lease Term",
            data: chartData.data,
          },
        ],
        credits: {
          enabled: false,
        },
      })
    })
  },
}
